import React, { FC, ReactElement, useContext, useEffect, useReducer } from "react";

//@ts-ignore
import { LocalizationContext } from "react-localize";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare, faWindowClose } from "@fortawesome/free-solid-svg-icons";

import "./styles.sass";

import { ScreenType } from "Constants";
import ReservationService from "Services/reservation.service";
import { GetCountriesResult, ReservationType } from "Interfaces/GetReservations";
import { ReservationResult, ReservationResultWeeks, Term } from "Interfaces/BookResort";
import { MvTextOrEdit } from "Generic/MvTextOrEdit";
import MvSelect from "Generic/MvSelect";
import { Actions, GuestName, GuestProfileRequest, GuestRadioButton, GuestTerms, InitState, PageErrorType, PageErrors, ReservationDetails } from "./types";
import { ArrivingGuestInfoReducer } from "./ArrivingGuestInfoReducer";
import Item from "Interfaces/ItemInterface";
import MvLoader from "Generic/MvLoader/MvLoader";
import { MvPrimaryBtn } from "Generic/MvPrimaryBtn";
import { ADDRESS, BONVOYNUMBER, CANADA, CITY, COUNTRY, EMAIL, FIRSTNAME, LASTNAME, PHONE, STATE, USA, ZIPCODE } from "./strings";
import { GuestDetail } from 'Components/Pages/Summary/AdditionalGuestProfile/AdditionalGuestProfile';
import { MvTermsConditions } from "Generic/MvTermsConditions";

import MvIcon from "Generic/MvIcon";
import moment from "moment";
import ToolTip from "Generic/ToolTip";
import { Tip } from 'Interfaces/TipInterface';
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Props = {
    token: string;
    lang: string;
    resId: string;
    setScreenType(screenType: ScreenType): void;
};

const ArrivingGuestInfo: FC<any> = (props: Props): ReactElement => {

    const [reducerState, dispatch] = useReducer(ArrivingGuestInfoReducer, InitState);

    const { localize } = useContext(LocalizationContext);

    const reservationService: ReservationService = new ReservationService();
    const addGuestTip: [Tip] = [
        {
          label: "",
          desc: "static.content.sr-tip-add-guest"
        }
      ];
    const queryString: string = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const callFrom: string = String(urlParams.get('callFrom'));
    const confirmationNumber: number = Number(urlParams.get('confirmationNumber'));
    const inventoryId: string = String(urlParams.get('inventoryId'));

    useEffect(() => {
        const reservationID: number = Number(urlParams.get('resId'));
        console.log('resIdTest', props.resId);
        if(callFrom == "points") {
            let dataLoading: [Promise<ReservationResult>, Promise<GetCountriesResult[]>, Promise<GuestTerms[]>] = [
                reservationService.getReservation(reservationID, ReservationType.UPCOMING),
                reservationService.getCountries(),
                reservationService.getTermsForArrivingGuestInfo()
            ];

            Promise.all(dataLoading).then((result: any[]) => {

                const reservationResult: ReservationResult = result[0];

                const guestProfile: GuestName[] = reservationResult.additionalGuests.map((guestProfile: GuestDetail) => {
                    return {
                        firstName: guestProfile.firstName,
                        lastName: guestProfile.lastName,
                        errors: {
                            firstNameError: false,
                            lastNameError: false
                        }
                    }
                });

                const bonvoyNumber = reservationResult.primaryGuest.memberships.length > 0 ? reservationResult.primaryGuest.memberships.find((entry: any) => {
                    return entry.membershipType === "MRW";
                }).membershipId : '';

                const guestRadioButtons = result[2].filter((guestTerm: GuestTerms) => {
                    // return guestTermRegex.test(guestTerm.nodename);
                    return guestTerm.nodename.startsWith("guest-radio");
                }).map((guestTerm: GuestTerms) => {
                    const singleTerm = {
                        description: guestTerm.description.replace("<p>", "").replace("</p>", ""),
                        checked: false
                    };

                    return singleTerm;
                });

                
                const reservationDetails: ReservationDetails = {
                    firstName: reservationResult.primaryGuest.firstName,
                    lastName: reservationResult.primaryGuest.lastName,
                    address: reservationResult.primaryGuest.address.addressLine1 + " " + reservationResult.primaryGuest.address.addressLine2,
                    city: reservationResult.primaryGuest.address.city,
                    state: reservationResult.primaryGuest.address.state,
                    zipcode: reservationResult.primaryGuest.address.postalCode,
                    country: reservationResult.primaryGuest.address.country,
                    email: reservationResult.primaryGuest.email,
                    phone: reservationResult.primaryGuest.phone,
                    bonvoyNumber: bonvoyNumber,
                    guestNames: guestProfile,
                    numOfGuests: reservationResult.reservationDetails.numOfGuests,
                    checkInDate: reservationResult.reservationDetails.checkInDate,
                    numOfNights: reservationResult.reservationDetails.numOfNights,
                    roomTypeDescription: reservationResult.reservationDetails.roomType.description,
                    reservationConfirmationNumber: reservationResult.reservationConfirmationNumber,
                    resortName: reservationResult.reservationDetails.resortName,
                    resortLocation: reservationResult.reservationDetails.resortLocation,
                    guestRadioButton: guestRadioButtons,
                    originalPrimaryGuestInfo: reservationResult.primaryGuest,
                    orignialGuestInfo: guestProfile,
                    ownerStayOption: "",
                    intentToStay: "Yes",
                };


                console.log("Terms from API: " + JSON.stringify(result[2]));

                const terms: Term[] = result[2].filter((guestTerm: GuestTerms) => {
                    // return guestTermRegex.test(guestTerm.nodename);
                    return guestTerm.nodename.startsWith("guest-names-terms-conditions");
                }).map((guestTerm: GuestTerms) => {
                    const nodename = guestTerm.nodename.replace("guest-names-terms-conditions","")
                    const singleTerm: Term = {
                        type: guestTerm.nodename,
                        acknowledgementNeeded: guestTerm.acknowledgementNeeded,
                        name: guestTerm.name,
                        description: guestTerm.description,
                        versionId: guestTerm.versionId,
                        checked: false,
                    };

                    return singleTerm;
                });

                console.log("Terms from formatting: " + JSON.stringify(terms));

                dispatch({
                    type: Actions.SETDATA,
                    payload: {reservationDetails: reservationDetails, countries: result[1], terms: terms}
                })
                manageTerms(true, true);
            }).catch((error: any) => {
                const errMsg = error.message ? `${error.message}` : "Unspecified error";
                console.log("errMsg",errMsg);

                dispatch({
                    type: Actions.ERROR,
                    payload: { type: "apiError" }
                });
            });
        } else {
            let dataLoading: [Promise<any>, Promise<GuestTerms[]>, Promise<GetCountriesResult[]>] = [
                reservationService.getReservationWeeks({ confirmationNumber, inventoryId }),
                reservationService.getTermsForArrivingGuestInfo(),
                reservationService.getCountries(),
            ];

            Promise.all(dataLoading).then((result: any[]) => {
                const guestRadioButtons = result[1].filter((guestTerm: GuestTerms) => {
                    // return guestTermRegex.test(guestTerm.nodename);
                    return guestTerm.nodename.startsWith("guest-radio");
                }).map((guestTerm: GuestTerms) => {
                    const singleTerm = {
                        description: guestTerm.description.replace("<p>", "").replace("</p>", ""),
                        checked: false
                    };

                    return singleTerm;
                });

                
                const reservationDetails: ReservationDetails = {
                    firstName: "",
                    lastName: "",
                    address: " ",
                    city: "",
                    state: "",
                    zipcode: "",
                    country: "",
                    email: "",
                    phone: "",
                    bonvoyNumber: "",
                    guestNames: [],
                    numOfGuests: 0,
                    checkInDate: result[0].CheckInDate,
                    numOfNights: result[0].NumberOfNights,
                    roomTypeDescription: result[0].RoomType,
                    reservationConfirmationNumber: result[0].Confirmation,
                    resortName: result[0].ResortName,
                    resortLocation: result[0].Location.city +','+ result[0].Location.state + ',' + result[0].Location.country,
                    guestRadioButton: guestRadioButtons,
                    originalPrimaryGuestInfo: [],
                    orignialGuestInfo: [],
                    ownerStayOption: "",
                    intentToStay: "Yes",
                };
                const terms: Term[] = result[1].filter((guestTerm: GuestTerms) => {
                    // return guestTermRegex.test(guestTerm.nodename);
                    return guestTerm.nodename.startsWith("guest-names-terms-conditions");
                }).map((guestTerm: GuestTerms) => {
                    const nodename = guestTerm.nodename.replace("guest-names-terms-conditions","")
                    const singleTerm: Term = {
                        type: guestTerm.nodename,
                        acknowledgementNeeded: guestTerm.acknowledgementNeeded,
                        name: guestTerm.name,
                        description: guestTerm.description,
                        versionId: guestTerm.versionId,
                        checked: false,
                    };

                    return singleTerm;
                });

                console.log("Terms from formatting: " + JSON.stringify(terms));

                dispatch({
                    type: Actions.SETDATA,
                    payload: {reservationDetails: reservationDetails, countries: result[2], terms: terms}
                })
                manageTerms(true, true);        
                //setPrimaryGuestName(["","","","","","","","","", ""]);
            }).catch((error: any) => {
                console.log('not points error', error);
                const errMsg = error.message ? `${error.message}` : "Unspecified error";
                console.log("errMsg", error);

                dispatch({
                    type: Actions.ERROR,
                    payload: { type: "apiError" }
                });
            });
        }
    },[]);

    // useEffect(()=>{
    //     const err = reducerState.pageErrors;
    //     let hasError = null
    //     Object.values(err).forEach(function eachValue(key) {
    //         key.isErrored && (hasError = true)
    //     })
    //     if(reducerState.terms.length == 0 || reducerState.terms.find(function(o){ return o.checked===false })){ (hasError = true) }

    //     dispatch({
    //         type: Actions.ISSUBMIT,
    //         payload: {isSubmitDisable: hasError ? hasError : false}
    //     })
    // },[reducerState.pageErrors])

    function getCountries(): Item[] {
        if(!reducerState.countries || reducerState.countries.length === 0) {
            return [];
        }

        return reducerState.countries.map((country: GetCountriesResult) => {
            return {
                value: country.Name,
                description: country.Name
            }
        });
    }

    function getStates(): Item[] {
        if(!reducerState.reservationResult || !reducerState.reservationResult.country) {
            return [];
        }
        const countryName: string = reducerState.reservationResult.country;

        const countryObject: GetCountriesResult = reducerState.countries.find((country: GetCountriesResult) => {
            return country.Name === countryName;
        }) || {} as GetCountriesResult;

        return countryObject.State.map((country: GetCountriesResult) => {
            return {
                value: country.Name,
                description: country.Description
            }
        });
    }

    function isInvalidInput(fieldName: string, value: string): boolean {
        if(fieldName === ADDRESS && value === "") {
            return true;
        } else if(fieldName === CITY && value === "") {
            return true;
        } else if(fieldName === ZIPCODE) {
            if(value === "") {
                return true;
            }

            if(reducerState.reservationResult.country === USA && !isValidUSZip(value)) {
                return true;
            }

            if(reducerState.reservationResult.country === CANADA && !isValidCanadaZip(value)) {
                return true;
            }
        } else if(fieldName === EMAIL && !isValidEmail(value)) {
            if(value === "") {
                return true;
            }
            if(!isValidEmail(value)) {
                return true;
            }
        } else if(fieldName === PHONE && !isValidPhoneNumber(value)) {
            return true;
        } else if(fieldName === FIRSTNAME || fieldName === LASTNAME) {
            // return !(!!value && !!value.trim());
            //  || !(value.match(/^[ a-z]+$/i))
            return !value || value.trim() === "" || isValidName(value); 
        }
        // if(fieldName === BONVOYNUMBER && !isValidBonvoyNumber(value)){
        //     return true;
        // }  
        return false;
    }

    function handleInputChange(fieldName: string, value: string): void {
        if(isInvalidInput(fieldName, value)) {
            dispatch({
                type: Actions.TOGGLEPRIMARYINFOERROR,
                payload: {field: fieldName}
            })
        } else {
            dispatch({
                type: Actions.ADDPRIMARYGUESTINFO,
                payload: {fieldName: fieldName, value: value}
            })
            const origanlInfo = reducerState.reservationResult.originalPrimaryGuestInfo;
            const fullName = origanlInfo.firstName+origanlInfo.lastName;
            let isTerm = false;
            if(fieldName === FIRSTNAME && fullName === value+reducerState.reservationResult.lastName) {
                isTerm = true;
            } else if(fieldName === LASTNAME && fullName === reducerState.reservationResult.firstName+value) {
                isTerm = true;
            }
            // I do NOT intend to stay
            let intnd = true;
            if(reducerState.reservationResult.ownerStayOption == "NO") {
                intnd = false
            }
            (fieldName === FIRSTNAME || fieldName === LASTNAME) && manageTerms(isTerm, intnd);
        }
    }

    function manageTerms(isTerm:boolean, intend:boolean) {
        const termContainer:any = document.getElementById('term-container');
            if( callFrom === 'points') {
                if(isTerm && intend) {
                    termContainer.classList.add('display-none');
                    dispatch({
                        type: Actions.RESETTERMS,
                        payload: {type: ""}
                    })
                } else {
                    termContainer.classList.remove('display-none');
                }
            } else {
                if(intend) {
                    termContainer.classList.add('display-none');
                    dispatch({
                        type: Actions.RESETTERMS,
                        payload: {type: ""}
                    })
                } else {
                    termContainer.classList.remove('display-none');
                }
            }
        console.log('Analytic data called');    
        logAnalyticData({ 
            event: 'guestNames', 
            siteSection: callFrom === 'points' ? 'Points' : 'Weeks', 
            pageName:'Guest Names', 
            website:'' 
            }, {
            ownerActivity:"Guest Names",
            ownerType: "Enrolled",
            errorMessage: "", 
        })
    
    }

    function handleInputBlur(fieldName: string, event: React.FocusEvent<HTMLInputElement>):void {
        //TODO: make same changes for error handling as handleSelectChange
        if(isInvalidInput(fieldName, event.target.value)) {
            dispatch({
                type: Actions.TOGGLEPRIMARYINFOERROR,
                payload: {field: fieldName}
            })
        } else {
            dispatch({
                type: Actions.ADDPRIMARYGUESTINFO,
                payload: {fieldName: fieldName, value: event.target.value}
            });
        }
    }

    function handleSelectChange(valueFieldName: string, descriptionFieldName: string, data: any): void {
        if(valueFieldName === COUNTRY) {
            // const selectedCountry = reducerState.countries.find(x => x.Name === data.value);
            dispatch({
                type: Actions.ADDPRIMARYGUESTINFO,
                payload: {fieldName: valueFieldName, value: data.value}
            })
        }

        if(valueFieldName === STATE) {
            dispatch({
                type: Actions.ADDPRIMARYGUESTINFO,
                payload: {fieldName: valueFieldName, value: data.value}
            });
        }
    }

    function handleSubmit(): void {
        console.log('data', reducerState.reservationResult);
        trackAnalyticData('guestNamesSubmit');
        let validationMap = checkAllErrorsinPage();

        let isValid: boolean = true;
        if(callFrom === 'points') {
        validationMap.forEach((value: Boolean, key: String) => {
            if(value) {
                isValid = false;
            }
        });
        } else {
            isValid = true;
        }

        if(!isValid) {
            //error
            dispatch({
                type: Actions.ERROR,
                payload: {type:"globalError", errorMap: validationMap}
            });
        }
        else {
            const result = reducerState.reservationResult;
            const associateEid: string = urlParams.get('associateEid') || '';
            const originalInfo = reducerState.reservationResult.originalPrimaryGuestInfo;
            const guestInfoRequest : GuestProfileRequest =  {
                confirmationNumber: result.reservationConfirmationNumber,
                ownerStayOption: localize("static.content.radio-button-option-1"),
                intentToStay: "Yes",
                primaryFirstName: result.firstName,
                primaryLastName: result.lastName,
                address1: result.address,
                address2: "",
                city: result.city,
                state: result.state,
                zipCode: result.zipcode,
                country: result.country,
                email: result.email,
                contactNumber: result.phone,
                marriottBonvoyNumber: result.bonvoyNumber,
                orignialGuestInfo: getGuestInfoObj(result.orignialGuestInfo, [], 'orignal'),
                newGuestInfo: getGuestInfoObj(result.guestNames, result.orignialGuestInfo, 'new'),
                eid: associateEid,
                ownerFirstName: originalInfo.firstName,
                ownerLastName: originalInfo.lastName,
                resortName: result.resortName,
                checkInDate: result.checkInDate,
            }

            const callFrom: string = urlParams.get('callFrom') || '';
            let additionalGuestStr = '';
            if(reducerState.reservationResult.ownerStayOption == "NO"){    
                // delete guestInfoRequest.orignialGuestInfo;
                guestInfoRequest.newGuestInfo = "Remove all additional guest";
                guestInfoRequest.ownerStayOption = localize("static.content.radio-button-option-2");
                guestInfoRequest.intentToStay = "No";
            } else if(Array.isArray(guestInfoRequest.newGuestInfo) && guestInfoRequest.newGuestInfo && guestInfoRequest.newGuestInfo.length > 0 ) {
                guestInfoRequest.newGuestInfo.map((guest)=>{
                    additionalGuestStr += `${guest.firstName+guest.lastName}`
                })
            }
            const resId: number = Number(urlParams.get('resId'));
            // Updating the regEx to include unicode char --> AM-5654
            const regx = /^[ 0-9a-z`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~\u0080-\u00FF\u0100-\u017F\u02BB\u2000-\u206F]+$/i;
            let isErr;
            if( callFrom == 'points') {
            let guestInfoString = ""
            console.log('guestInfoRequest', guestInfoRequest);
            for (let [key, value] of Object.entries(guestInfoRequest)) {
                if (key === 'resortName') continue;
                if(!Array.isArray(value)) {
                    if(callFrom === 'points') {
                        guestInfoString += value.toString()
                    } else {
                        guestInfoString += value
                    }
                }
            }
            
            isErr = !regx.test((guestInfoString.trim()).replace(/(\r\n|\n|\r)/gm, ""))
            // ((Object.values(guestInfoRequest)).toString().match(regx));
            } else {
                isErr = false;
            }
            
            if(!isErr && additionalGuestStr){
                isErr = !(regx.test((additionalGuestStr.trim()).replace(/(\r\n|\n|\r)/gm, "")))
                // (additionalGuestStr.match(regx))
            }

            if(isErr) {
                dispatch({
                    type: Actions.ERROR,
                    payload: { type: PageErrorType.langError, message: localize('static.content.foreign-char-error') }
                })
            } else {
                let str = ''
                reducerState.terms && reducerState.terms.map((term)=>{ 
                    str +=`• `+term.description+` `;
                })
                str.replace(/<\/?[^>]+(>|$)/g, "")
                let newStr = decodeHtmlEntities(str)
                newStr && (guestInfoRequest.termsAndConditions = newStr);
                
                const termContainer:any = document.getElementById('term-container');
                (termContainer && termContainer.classList.contains('display-none')) && (guestInfoRequest.termsAndConditions = "")
                if(callFrom == "points") {
                    guestInfoRequest.reason = "MVC Points"
                } else {
                    guestInfoRequest.reason = "Legacy MVC"
                }
                dispatch({
                    type: Actions.API_LOADING,
                    payload: true
                })
                
                reservationService.submitGuestProfile(guestInfoRequest, resId).then((resp: any) => {
                    props.setScreenType(ScreenType.GUEST_INFO_CONFIRMATION);
                    dispatch({
                        type: Actions.API_LOADING,
                        payload: false
                    })
                })
                .catch((error: any) => {
                    dispatch({
                        type: Actions.ERROR,
                        payload: { PageErrorType: PageErrorType.apiSubmitError }
                    })
                });
            }
        }
        trackAnalyticData('guestNamesSubmit');
    }

    function decodeHtmlEntities(strVal:string) {
        var doc = new DOMParser().parseFromString(strVal, 'text/html');
        return doc.documentElement.textContent;
    }

    function getGuestInfoObj(guestNames:any, orignalGst:any, name:string):any {
        if(name == "orignal" || orignalGst.length == 0) {
            return guestNames.map((gn:any)=> {
                return {firstName: gn.firstName, lastName: gn.lastName}
            })
        } else {
            const newArr:any = []
            guestNames.map((gn:any, i:number)=> {
                if(gn.firstName != orignalGst[i].firstName || gn.lastName != orignalGst[i].lastName)
                    newArr.push({firstName: gn.firstName, lastName: gn.lastName})
            })
            return newArr
        }
    }

    function checkAllErrorsinPage(): Map<String, Boolean> {
        let validationMap = new Map<String, Boolean>();

        validationMap.set("termsError", false);
        if(!isTermsValid()) {
            validationMap.set("termsError", true);
        }

        validationMap.set("additionalGuestError", false);
        if(!isAdditinalGuestNamesValid()) {
            validationMap.set("additionalGuestError", true);
        }

        validationMap.set("addressError", false);
        if(isInvalidInput(ADDRESS, reducerState.reservationResult.address)) {
            validationMap.set("addressError", true);
        }

        validationMap.set("cityError", false);
        if(isInvalidInput(CITY, reducerState.reservationResult.city)) {
            validationMap.set("cityError", true);
        }

        validationMap.set("stateError", false);
        if(isInvalidInput(STATE, reducerState.reservationResult.state)) {
            validationMap.set("stateError", true);
        }

        validationMap.set("zipError", false);
        if(isInvalidInput(ZIPCODE, reducerState.reservationResult.zipcode)) {
            validationMap.set("zipError", true);
        }

        validationMap.set("emailError", false);
        if(isInvalidInput(EMAIL, reducerState.reservationResult.email)) {
            validationMap.set("emailError", true);
        }

        validationMap.set("phoneError", false);
        if(isInvalidInput(PHONE, reducerState.reservationResult.phone)) {
            validationMap.set("phoneError", true);
        }

        validationMap.set("bonvoyError", false);
        if(isInvalidInput(BONVOYNUMBER, reducerState.reservationResult.bonvoyNumber)) {
            validationMap.set("bonvoyError", true);
        }

        return validationMap;
    }

    function isAdditinalGuestNamesValid(): boolean {
        let isValid: boolean = true;

        const guestNames: GuestName[] = reducerState.reservationResult.guestNames;

        if(guestNames.length === 0) {
            return true;
        }

        guestNames.forEach((guestName: GuestName) => {
            if(guestName.firstName.trim().length === 0 || guestName.lastName.trim().length === 0) {
                isValid = false;
            }
        });

        return isValid;
    }

    function isTermsValid(): boolean {
        const terms: Term[] = reducerState.terms;

        let isValid: boolean = true;

        terms.forEach((term: Term) => {
            if(term.acknowledgementNeeded === "true" && !term.checked) {
                isValid = false;
            }
        });
        const termContainer:any = document.getElementById('term-container');
        (termContainer && termContainer.classList.contains('display-none')) && (isValid = true)
        return isValid;
    }

    function hasPageErrors(): boolean {
        let hasPageErrors: boolean = false;

        return Object.entries(reducerState.pageErrors).some((key, value) => key[1].isErrored) 
                    || reducerState.reservationResult.guestNames.some((guestName: GuestName) => guestName.errors.firstNameError || guestName.errors.lastNameError)
                    || reducerState.terms.some((term: Term) => term.acknowledgementNeeded === "true" && !term.checked);
    }

    function isValidName(name: string): boolean {
        const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return /\d/.test(name) || format.test(name);
    }

    function isValidEmail(email: string): boolean {
        const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return re.test(email);
    }

    function isValidPhoneNumber(pNumber: string): boolean {
        return (/^[0-9]{1,14}$/.test(pNumber));
    }

    function isValidBonvoyNumber(bonvoyNumber: string): boolean {
        return (/^[0-9]{9}$/.test(bonvoyNumber));
    }

    function isValidUSZip(sZip: string): boolean {
        return (!(/^0*$/.test(sZip)) && !(/^[0-9]{6}$/.test(sZip)) && /^[0-9]{5}(?:-[0-9]{4})?$/.test(sZip)) || (/^[0-9]{9}$/.test(sZip));
    }

    function isValidCanadaZip(sZip: string): boolean {
        return /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(sZip);
    }

    function handleAdditionalGuestProfileEdit(field: string, index: number, value: string): void {
        // console.log(field + " " + index + " " + value);
        if(!value || value === "") {
            //set error here
            dispatch({
                type: Actions.ADDITIONALGUESTINFOMODIFYERROR,
                payload: {index: index, fieldName: field, value: value}
            })
        } else {
            dispatch({
                type: Actions.ADDITIONALGUESTINFOMODIFY,
                payload: {index: index, fieldName: field}
            });
        }
    }

    function handleAdditionalGuestProfileBlur(field: string, event: React.FocusEvent<HTMLInputElement>, index: number) {
        // console.log(field + " " + index);
        if(!event.target.value || event.target.value === "") {
            //set error here
            dispatch({
                type: Actions.ADDITIONALGUESTINFOMODIFYERROR,
                payload: {index: index, fieldName: field, value: event.target.value}
            })
        } else {
            dispatch({
                type: Actions.ADDITIONALGUESTINFOMODIFY,
                payload: {index: index, fieldName: field, value: event.target.value}
            });
        }
    }

    function removeAdditionalGuest(index: number) {
        dispatch({
            type: Actions.REMOVEADDITIONALGUEST,
            payload: {index: index}
        });
    }

    function addEmptyGuestName() {
        dispatch({
            type: Actions.ADDADDITIONALGUESTS,
            payload: {}
        });
    }

    function displayAddButton(): boolean {
        // console.log("guest array length: " + reducerState.reservationResult.guestNames.length + " number of guests: " + reducerState.reservationResult.numOfGuests);
        if(reducerState.reservationResult.guestNames.length + 1 > 5) {
            return false;
        }

        if(reducerState.reservationResult.guestNames.length + 1 >= reducerState.reservationResult.numOfGuests) {
            return false;
        }
        return true;
    }

    function handleClickOnTnC(type: string) {
        dispatch({
            type: Actions.TERMS,
            payload: {type: type}
        })
    }

    function toggleInfoBox() {
        let angle:any = document.getElementById('arrow-icon');
        let info:any = document.getElementById('info-box-visiblity');
        angle.classList.toggle("angleUp");
        angle.classList.toggle("angleDown");
        info.classList.toggle("visible-guest-info");
        info.classList.toggle("hidden-guest-info");
    }

    function GuestBookinInfo(): any {
        const infoArr = [{key:`${localize("static.content.check-in")}:`, value:`${moment(reducerState.reservationResult.checkInDate).format('DD MMM YYYY')}`},
                        {key:`${localize("static.content.num-of-nights")}:`, value:`${reducerState.reservationResult.numOfNights} Nights`},
                        {key:`${localize("static.content.room-type")}:`, value:`${reducerState.reservationResult.roomTypeDescription}`},
                        {key:`${localize("static.content.confirmation-number-label")}:`, value:`${reducerState.reservationResult.reservationConfirmationNumber}`},
                        {key:localize("static.content.primary-guest-label-guest-names"), value:`${reducerState.reservationResult.originalPrimaryGuestInfo.firstName+" "+reducerState.reservationResult.originalPrimaryGuestInfo.lastName}`}];
        return (    <div className="arriving-guest-info-container">
                        <div className="arriving-guest-info-box">
                            <p className="arriving-guest-info-heading">
                                {reducerState.reservationResult.resortName}
                                {<i className="filter-title-svg mobile-arrow-icon angleUp" id="arrow-icon" onClick={()=>toggleInfoBox()}>
                                    <MvIcon icon="angleUp" width="20px" height="20px"/>
                                    <MvIcon icon="angleDown" width="20px" height="20px"/> 
                                </i>
                                }
                            </p>
                            <p className="arriving-guest-info-subheading">{reducerState.reservationResult.resortLocation}</p>
                            <div className="hidden-guest-info" id="info-box-visiblity">
                                <br />
                                {infoArr.map((info)=> 
                                    {
                                        let maskedAttribute = info.key === 'Guest Names:' ? true : false;
                                        console.log('maskedAttribute', maskedAttribute);
                                        if(maskedAttribute) {
                                            return <div data-cs-mask className="arriving-guest-info-details">
                                            <label className="box-label">{info.key}</label>
                                            <p className="box-value">{info.value}</p>
                                        </div>
                                        } else {
                                            return <div className="arriving-guest-info-details">
                                            <label className="box-label">{info.key}</label>
                                            <p className="box-value">{info.value}</p>
                                        </div>
                                        }
                                        
                                    })
                                }
                                <div data-cs-mask className="arriving-guest-info-details">
                                    <label className="box-label guest-names-label">{localize("static.content.primary-guest-label-additional-guest-names")}</label>
                                </div>     
                                <div className="arriving-guest-info-details">
                                    <p className="box-value guest-names">
                                        {reducerState.reservationResult.orignialGuestInfo.length > 0 && 
                                            reducerState.reservationResult.orignialGuestInfo.map((guestName, index) => {
                                                const comma = reducerState.reservationResult.orignialGuestInfo.length == (index+1) ? "" : ", "
                                                            return (
                                                                guestName.firstName+" "+guestName.lastName+comma
                                                            );
                                            })
                                        }
                                    </p>
                                </div> 
                            </div>              
                        </div>
                    </div>
                )
    }

    function GuestBookinWeeksInfo(): any {
        const infoArr = [{key:`${localize("static.content.check-in")}:`, value:`${moment(reducerState.reservationResult.checkInDate).format('DD MMM YYYY')}`},
                        {key:`${localize("static.content.num-of-nights")}:`, value:`${reducerState.reservationResult.numOfNights} Nights`},
                        // {key:`${localize("static.content.room-type")}:`, value:`${reducerState.reservationResult.roomTypeDescription}`},
                        {key:`${localize("static.content.confirmation-number-label")}:`, value:`${reducerState.reservationResult.reservationConfirmationNumber}`}];
                        // {key:localize("static.content.primary-guest-label-guest-names"), value:`${reducerState.reservationResult.originalPrimaryGuestInfo.firstName+" "+reducerState.reservationResult.originalPrimaryGuestInfo.lastName}`}];
        return (    <div className="arriving-guest-info-container">
                        <div className="arriving-guest-info-box">
                            <p className="arriving-guest-info-heading">
                                {reducerState.reservationResult.resortName}
                                {<i className="filter-title-svg mobile-arrow-icon angleUp" id="arrow-icon" onClick={()=>toggleInfoBox()}>
                                    <MvIcon icon="angleUp" width="20px" height="20px"/>
                                    <MvIcon icon="angleDown" width="20px" height="20px"/> 
                                </i>
                                }
                            </p>
                            <p className="arriving-guest-info-subheading">{reducerState.reservationResult.resortLocation}</p>
                            <div className="hidden-guest-info" id="info-box-visiblity">
                                <br />
                                {infoArr.map((info)=> 
                                    {
                                        let maskedAttribute = info.key === 'Guest Names:' ? true : false;
                                        console.log('maskedAttribute', maskedAttribute);
                                        if(maskedAttribute) {
                                            return <div data-cs-mask className="arriving-guest-info-details">
                                            <label className="box-label">{info.key}</label>
                                            <p className="box-value"></p>
                                        </div>
                                        } else {
                                            return <div className="arriving-guest-info-details">
                                            <label className="box-label">{info.key}</label>
                                            <p className="box-value">{info.value}</p>
                                        </div>
                                        }
                                        
                                    })
                                }
                                {/* <div data-cs-mask className="arriving-guest-info-details">
                                    <label className="box-label guest-names-label">{localize("static.content.primary-guest-label-additional-guest-names")}</label>
                                </div>     
                                <div className="arriving-guest-info-details">
                                    <p className="box-value guest-names">
                                        {reducerState.reservationResult.orignialGuestInfo.length > 0 && 
                                            reducerState.reservationResult.orignialGuestInfo.map((guestName, index) => {
                                                const comma = reducerState.reservationResult.orignialGuestInfo.length == (index+1) ? "" : ", "
                                                            return (
                                                                guestName.firstName+" "+guestName.lastName+comma
                                                            );
                                            })
                                        }
                                    </p>
                                </div>  */}
                            </div>              
                        </div>
                    </div>
                )
    }

    function toggleRadioButton(radioAction: string) {
        dispatch({
            type: Actions.ADDPRIMARYGUESTINFO,
            payload: {fieldName: "ownerStayOption", value: radioAction}
        })
        manageGuestAndAdditionalGuest(radioAction === "YES" ? true : false);
        dispatch({
            type: Actions.SETRADIOBUTTON,
            payload: {action: radioAction}
        });
        setTimeout(() => {
            const origanlInfo = reducerState.reservationResult.originalPrimaryGuestInfo;
            const fullName = (origanlInfo.firstName+origanlInfo.lastName) || "";
            const addFirstName:any = document.getElementById('add_first_name');
            const addLastName:any = document.getElementById('add_last_name');
            let isTerm = false;
            if(fullName === addFirstName.value+addLastName.value) {
                isTerm = true;
            } else {
                isTerm = false;
            }
            manageTerms(isTerm, radioAction === "YES" ? true : false);
        }, 100);
    }

    function manageGuestAndAdditionalGuest(intendRadio:boolean) {
        const additionalGuestContainer:any = document.getElementById('additional-guest-container');
        const origanlInfo = reducerState.reservationResult.originalPrimaryGuestInfo;
        if(intendRadio) {
            callFrom == "points" && additionalGuestContainer.classList.remove('display-none');   
            reducerState.reservationResult.guestNames = reducerState.reservationResult.orignialGuestInfo;
            const bonvoyNumber = callFrom == "points" && origanlInfo.memberships.length > 0 ? origanlInfo.memberships.find((entry: any) => {
                return entry.membershipType === "MRW";
            }).membershipId : '';
            const arr = callFrom == "points" ? [origanlInfo.firstName, 
                origanlInfo.lastName, 
                origanlInfo.address.addressLine1 + " " + origanlInfo.address.addressLine2, 
                origanlInfo.address.city, 
                origanlInfo.address.postalCode,
                origanlInfo.phone,
                origanlInfo.email,
                bonvoyNumber,
                origanlInfo.address.country,
                origanlInfo.address.state
            ]:[]
            callFrom == "points" && setPrimaryGuestName(arr);
        } else {
            if(callFrom === "points") {
                callFrom == "points" && additionalGuestContainer.classList.add('display-none');
                reducerState.reservationResult.guestNames = [];
            setPrimaryGuestName(["","","","","","","","",reducerState.countries[0].Name, ""]);
            }
        }
    }

    function setPrimaryGuestName(info:any[]) {
        // dispatch({
        //     type: Actions.ADDPRIMARYGUESTINFO,
        //     payload: {fieldName: FIRSTNAME, value: firstname}
        // })
        // dispatch({
        //     type: Actions.ADDPRIMARYGUESTINFO,
        //     payload: {fieldName: LASTNAME, value: lastname}
        // })
        console.log("reducerState.reservationResult",reducerState.reservationResult);
        // , ADDRESS, CITY, STATE, ZIPCODE
        [FIRSTNAME, LASTNAME, ADDRESS, CITY, ZIPCODE, PHONE, EMAIL, BONVOYNUMBER, COUNTRY, STATE].map((field, i)=>{
            
            const data = {
                value: info[i]
            }
            if(field == COUNTRY) {
                handleSelectChange(field, '', data)
            } else if(field == STATE) {
                info[i] != "" && handleSelectChange(field, '', data)
            } else {
                dispatch({
                    type: Actions.ADDPRIMARYGUESTINFO,
                    payload: {fieldName: field, value: info[i] || ""}
                })
            }
        })
    }

    function isSubmitDisabled(): boolean {
        const pageErrors = reducerState.pageErrors;
        let isDisabled = false;
        
        //Check for page errors
        Object.values(pageErrors).forEach((error: any) => {
            // console.log(JSON.stringify(error));
            if(error.isErrored) {
                isDisabled = true;
            }
        });

        reducerState.reservationResult.guestNames.forEach((guestName: GuestName) => {
            if(guestName.errors.firstNameError || guestName.errors.lastNameError) {
                isDisabled = true;
            }
        });

        if(reducerState.reservationResult.firstName == "") {
            isDisabled = true;
        }

        if(reducerState.reservationResult.lastName =="") {
            isDisabled = true;
        }

        //check if all the radio buttons are not selected
        let isRadioNotSelected = true;
        reducerState.reservationResult.guestRadioButton.forEach((radioOption: GuestRadioButton) => {
            if(radioOption.checked) {
                isRadioNotSelected = false;
            }
        });

        let areAllBoxesNotChecked = false;
        //Check if all the terms are selected
        const termContainer:any = document.getElementById('term-container');
        console.log("guestRadioButton[0].checked",termContainer && termContainer.classList.contains('display-none'))
        if(termContainer && !termContainer.classList.contains('display-none')) {
            reducerState.terms.forEach((term: Term) => {
                if(!term.checked) {
                    areAllBoxesNotChecked = true;
                }
            });
        }
        
        return isDisabled || isRadioNotSelected || areAllBoxesNotChecked
    }
    console.log("reducerState.reservationResult",reducerState.reservationResult)
    return (
        <div className={`arriving-guest-root ${window.location.hostname.includes('st01.www.vacationclubap.com') && 'arriving-guest-root-vcap'}`}>
            <h1 className="arriving-guest-change-header">{localize("static.content.guest-profile-header")}</h1>
            <span className="arriving-guest-change-second-header">{localize("static.content.guest-profile-header-subheader")}</span>
            {
                reducerState.isLoading &&
                <MvLoader show={true} >

                </MvLoader>
            }

            {
                !reducerState.isLoading && reducerState.pageErrors[PageErrorType.apiError].isErrored &&
                <div className="page-error">
                    <span>{reducerState.pageErrors.apiError.message}</span>
                </div>
            }
            {
                !reducerState.isLoading && !reducerState.pageErrors[PageErrorType.apiError].isErrored && 
                <div className="guest-info-box-display">
                    <div className="arriving-guest-primary-guest field-container">
                        <span className="arriving-guest-radio-button-header">{localize("static.content.radio-button-header")}</span>
                        <div className="arriving-guest-radio-buttons">
                            <div id="YES" className="arriving-guest-radio-buttons-single">
                                <input 
                                    type="radio"
                                    name="stay"
                                    checked={reducerState.reservationResult.ownerStayOption == "YES" ? true: false}
                                    onChange={(e) => {toggleRadioButton("YES"); trackAnalyticData('guestNamesStay')}}
                                />
                                <label onClick={() => toggleRadioButton("YES")}>{localize("static.content.radio-button-option-1")}</label> 
                            </div>
                            <div id="NO" className="arriving-guest-radio-buttons-single">
                                <input 
                                    type="radio"
                                    name="stay"
                                    checked={reducerState.reservationResult.ownerStayOption == "NO" ? true: false}
                                    onChange={(e) => {toggleRadioButton("NO"); trackAnalyticData('guestNamesNotStay')}}
                                />
                                <label onClick={() => toggleRadioButton("NO")}>{localize("static.content.radio-button-option-2")}</label> 
                            </div>
                        </div>
                        <div className="arriving-guest-change-primary-guest-info-header">
                            <span className="arriving-guest-radio-button-header">{localize("static.content.change-primary-guest-info-heading")}</span>
                            <hr/>
                        </div>
                        <div className="arriving-guest-change-primary-box-info-column">
                            <div className="mobile-view">
                                {callFrom == "points" ? GuestBookinInfo() : GuestBookinWeeksInfo()}
                            </div>
                            <div className="arriving-guest-change-primary-box-info-column-first">
                            <div className="two-columns-box">
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(FIRSTNAME, e)}
                                        onBlur={(e) => handleInputBlur(FIRSTNAME, e)}
                                        value={reducerState.reservationResult.firstName}
                                        placeholder={"First Name"}
                                        globalTxData={'GlobalLinkNoTx'}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-first-name")}
                                        id={'add_first_name'}
                                        name={'add_first_name'}
                                        hasError={reducerState.pageErrors[PageErrorType.firstNameError].isErrored}
                                        errorMessage={reducerState.pageErrors[PageErrorType.firstNameError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(LASTNAME, e)}
                                        onBlur={(e) => handleInputBlur(LASTNAME, e)}
                                        value={reducerState.reservationResult.lastName}
                                        placeholder={"Last Name"}
                                        globalTxData={'GlobalLinkNoTx'}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-last-name")}
                                        id={'add_last_name'}
                                        name={'add_last_name'}
                                        hasError={reducerState.pageErrors[PageErrorType.lastNameError].isErrored}
                                        errorMessage={reducerState.pageErrors[PageErrorType.lastNameError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                </div>
                                <div className="one-column-box">
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(ADDRESS, e)}
                                        onBlur={(e) => handleInputBlur(ADDRESS, e)}
                                        value={reducerState.reservationResult.address}
                                        placeholder={"Address 1"}
                                        globalTxData={'GlobalLinkNoTx'}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-address")}
                                        id={'add_address'}
                                        name={'add_address'}
                                        hasError={reducerState.pageErrors[PageErrorType.addressError].isErrored}
                                        errorMessage={reducerState.pageErrors[PageErrorType.addressError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                </div>
                                <div className="two-columns-box">
                                    <div className="dropdown-box">
                                        <span className="mb-5">{localize("static.content.primary-guest-label-country")}</span>
                                        <MvSelect 
                                            name="add_country"
                                            label="Country"
                                            onChange={(e: any) => handleSelectChange(COUNTRY, 'countryDescription', e.target)}
                                            items={getCountries()}
                                            value={reducerState.reservationResult.country}
                                            required={true}
                                            hasError={reducerState.pageErrors[PageErrorType.countryError].isErrored}
                                            errorMessage={reducerState.pageErrors[PageErrorType.countryError].message}
                                        />
                                    </div>
                                    <div className="pt-5">
                                        <MvTextOrEdit 
                                            onChange={(e) => handleInputChange(CITY, e)}
                                            onBlur={(e) => handleInputBlur(CITY, e)}
                                            value={reducerState.reservationResult.city}
                                            placeholder={"City"}
                                            isEditing={true}
                                            hideLabel={false}
                                            label={localize("static.content.primary-guest-label-city")}
                                            id={'add_city'}
                                            name={'add_city'}
                                            hasError={reducerState.pageErrors[PageErrorType.cityError].isErrored}
                                            errorMessage={reducerState.pageErrors[PageErrorType.cityError].message}
                                            isRequired={true}
                                            inputComponent='text'
                                        />
                                    </div>
                                </div>
                                <div className="two-columns-box">
                                    <div className="dropdown-box">
                                        <span className="mb-5">{localize("static.content.primary-guest-label-state")}</span>
                                        <MvSelect 
                                            name="add_state"
                                            label="State"
                                            onChange={(e: any) => handleSelectChange(STATE, 'stateDescription', e.target)}
                                            items={getStates()}
                                            value={reducerState.reservationResult.state}
                                            required={true}
                                            hasError={reducerState.pageErrors[PageErrorType.stateError].isErrored}
                                            errorMessage={reducerState.pageErrors[PageErrorType.stateError].message}
                                        />
                                    </div>
                                    <div className="pt-5">
                                        <MvTextOrEdit 
                                            onChange={(e) => handleInputChange(ZIPCODE, e)}
                                            onBlur={(e) => handleInputBlur(ZIPCODE, e)}
                                            value={reducerState.reservationResult.zipcode}
                                            placeholder={"Zip"}
                                            isEditing={true}
                                            hideLabel={false}
                                            label={localize("static.content.primary-guest-label-zipcode")}
                                            id={'add_zip_code'}
                                            name={'add_zip_code'}
                                            hasError={reducerState.pageErrors[PageErrorType.zipError].isErrored}
                                            errorMessage={reducerState.pageErrors[PageErrorType.zipError].message}
                                            isRequired={true}
                                            inputComponent='text'
                                        />
                                    </div>
                                </div>
                                <div className="one-column-box">
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(EMAIL, e)}
                                        onBlur={(e) => handleInputBlur(EMAIL, e)}
                                        value={reducerState.reservationResult.email}
                                        placeholder={"Email"}
                                        globalTxData={'GlobalLinkNoTx'}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-email")}
                                        id={'add_email_address'}
                                        name={'add_email_address'}
                                        hasError={reducerState.pageErrors[PageErrorType.emailError].isErrored}
                                        errorMessage={reducerState.pageErrors[PageErrorType.emailError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                </div>
                                <div className="one-column-box">
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(PHONE, e)}
                                        onBlur={(e) => handleInputBlur(PHONE, e)}
                                        value={reducerState.reservationResult.phone}
                                        placeholder={"Phone"}
                                        globalTxData={'GlobalLinkNoTx'}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-contact-number")}
                                        id={'add_phone_number'}
                                        name={'add_phone_number'}
                                        hasError={reducerState.pageErrors[PageErrorType.phoneError].isErrored}
                                        errorMessage={reducerState.reservationResult.phone ? reducerState.pageErrors[PageErrorType.phoneValidationError].message : reducerState.pageErrors[PageErrorType.phoneError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                </div>
                                <div className="one-column-box">
                                    <MvTextOrEdit 
                                        onChange={(e) => handleInputChange(BONVOYNUMBER, e)}
                                        onBlur={(e) => handleInputBlur(BONVOYNUMBER, e)}
                                        value={reducerState.reservationResult.bonvoyNumber}
                                        placeholder={"Marriott Bonvoy number"}
                                        isEditing={true}
                                        hideLabel={false}
                                        label={localize("static.content.primary-guest-label-marriott-bonvoy")}
                                        id={'add_marriott_bonvoy'}
                                        name={'add_marriott_bonvoy'}
                                        hasError={reducerState.pageErrors[PageErrorType.bonvoyError].isErrored}
                                        errorMessage={reducerState.reservationResult.bonvoyNumber ? reducerState.pageErrors[PageErrorType.bonvoyValidationError].message : reducerState.pageErrors[PageErrorType.bonvoyError].message}
                                        isRequired={true}
                                        inputComponent='text'
                                    />
                                </div>
                            </div>
                            <div className="desktop-view">
                                {callFrom == "points" ? GuestBookinInfo() : GuestBookinWeeksInfo()}
                            </div>
                        </div>
                        {callFrom === 'points'?
                        <div id="additional-guest-container" className="arriving-guest-additional-guests-section">
                            <span className="arriving-guest-additional-guests-section-header">{localize("static.content.additional-guest-name-heading")}</span>
                            {
                                reducerState.reservationResult.guestNames.length > 0 && reducerState.reservationResult.guestNames.map((guestName: GuestName, index: number) => {
                                    return (
                                        <div className="arriving-guest-additional-guests-section-box">
                                            <div className="one-column-box-additional-guests">
                                                <MvTextOrEdit
                                                    onChange={(e) => handleAdditionalGuestProfileEdit("firstName", index, e)}
                                                    onBlur={(e) => handleAdditionalGuestProfileBlur("firstName", e, index)}
                                                    value={guestName.firstName}
                                                    placeholder={"First name"}
                                                    globalTxData={'GlobalLinkNoTx'}
                                                    isEditing={true}
                                                    hideLabel={false}
                                                    label={localize("static.content.additional-guest-name-first-name")}
                                                    id={'add_address'}
                                                    name={'add_address'}
                                                    hasError={guestName.errors.firstNameError}
                                                    errorMessage={"First name is mandatory"}
                                                    isRequired={true}
                                                    inputComponent='text' />
                                                <MvTextOrEdit
                                                    onChange={(e) => handleAdditionalGuestProfileEdit("lastName", index, e)}
                                                    onBlur={(e) => handleAdditionalGuestProfileBlur("lastName", e, index)}
                                                    value={guestName.lastName}
                                                    placeholder={"Last name"}
                                                    globalTxData={'GlobalLinkNoTx'}
                                                    isEditing={true}
                                                    hideLabel={false}
                                                    label={localize("static.content.additional-guest-name-last-name")}
                                                    id={'add_address'}
                                                    name={'add_address'}
                                                    hasError={guestName.errors.lastNameError}
                                                    errorMessage={"Last name is mandatory"}
                                                    isRequired={true}
                                                    inputComponent='text' />
                                            </div>
                                            <div className="one-column-box-x-icon" onClick={() => removeAdditionalGuest(index)}>
                                                <FontAwesomeIcon color="#079A8B" icon={faWindowClose} />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            <div className='row arrivingguest additionalGuest'>
                                <div className="fifty column guestDetails">
                                    <div className="single-input">
                                        <span className={`addItem ${!displayAddButton() ? 'disabled' : ''}`} onClick={() => displayAddButton() && addEmptyGuestName()}>+ {localize("static.content.sr-add-guest")}</span>
                                        <span>
                                            <ToolTip
                                            id='additional-guests-add'
                                            tabIndex={0}
                                            tip={addGuestTip}
                                            useRefToPosition={false}
                                            >
                                            <span className="question-icon">{"?"}</span>
                                            </ToolTip>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div> : '' }
                    </div>
                    
                </div>
            }
            {
                !reducerState.isLoading && !reducerState.pageErrors[PageErrorType.apiError].isErrored &&  
                <div>
                    <div id="term-container" className={`arriving-guest-primary-guest`}>
                        <div className="arriving-guest-terms">
                            <MvTermsConditions
                                heading={localize("static.content.terms-and-conditions-section-header").replace("<p>", "").replace("</p>", "")}
                                subHeading=""
                                instructions={reducerState.terms}
                                onChange={handleClickOnTnC}
                                submissionFailed={reducerState.pageErrors.tandcError.isErrored}
                            />
                        </div>
                    </div>
                    <div className="arriving-guest-button-container">
                        <MvPrimaryBtn 
                            isDisabled={isSubmitDisabled() || reducerState.apiLoading}
                            text={"Submit"}
                            submissionInProgress={false}
                            onClick={() => handleSubmit()}
                        />
                        {/* {reducerState.hasPageErrors && <span className="">Please correct the errors in the page</span>} */}
                        <div className="page-errors">
                            {
                                Object.keys(reducerState.pageErrors).map((key) => {
                                    const pageErrorObj = reducerState.pageErrors[(key as PageErrorType)];
                                    if(pageErrorObj.isErrored) {
                                        return (
                                            <div className="mv-inpu-err-msg">{pageErrorObj.message}</div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

ArrivingGuestInfo.contextTypes = LocalizationContext;
export {
    ArrivingGuestInfo,
};